export default "__VITE_ASSET__CVXPwqP9__"